import { createSlice } from "@reduxjs/toolkit";
import {
  FetchRecordingCourseAsync,
  FetchRecordingCourseDetailAsync,
  FetchRecordingCourseFrontendAsync,
  fetchOrderRecordingCourseAsync,
  fetchOrderRecordingCourseDetailAsync,
  FetchRecordingCourseFrontendDetailAsync,
} from "../thunk/RecordingCourse";

let initialState = {
  recordingCourseList: "",
  recordingCourseListError: "",
  recordingCourseListStatus: "",
  recordingCourseDetailList: "",
  recordingCourseDetailListError: "",
  recordingCourseDetailListStatus: "",
  recordingCourseFrontend: "",
  recordingCourseFrontendError: "",
  recordingCourseFrontendStatus: "",
  recordingCourseFrontendDetail: "",
  recordingCourseFrontendDetailError: "",
  recordingCourseFrontendDetailStatus: "",
  recordingCourseOrderList: "",
  recordingCourseOrderListError: "",
  recordingCourseOrderListStatus: "",
  recordingCourseOrderListDetail: "",
  recordingCourseOrderListDetailError: "",
  recordingCourseOrderListDetailStatus: "",
  buyStatus: false,
};

const RecordingCourseSlice = createSlice({
  name: "RecordingCourseSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(FetchRecordingCourseAsync.pending, (state) => {
      state.recordingCourseListStatus = "loading";
    });
    builder.addCase(FetchRecordingCourseAsync.fulfilled, (state, action) => {
      state.recordingCourseListStatus = "succeeded";
      state.recordingCourseList = action.payload;
    });

    builder.addCase(FetchRecordingCourseAsync.rejected, (state, action) => {
      state.recordingCourseListStatus = "failed";
      state.recordingCourseListError = action.error.message;
    });
    builder.addCase(FetchRecordingCourseFrontendAsync.pending, (state) => {
      state.recordingCourseFrontendStatus = "loading";
    });
    builder.addCase(
      FetchRecordingCourseFrontendAsync.fulfilled,
      (state, action) => {
        console.log(action.payload, "<<<action.payload");
        state.recordingCourseFrontendStatus = "succeeded";
        state.recordingCourseFrontend = action.payload;
      }
    );

    builder.addCase(
      FetchRecordingCourseFrontendAsync.rejected,
      (state, action) => {
        state.recordingCourseFrontendStatus = "failed";
        state.recordingCourseFrontendError = action.error.message;
      }
    );
    builder.addCase(FetchRecordingCourseDetailAsync.pending, (state) => {
      state.recordingCourseDetailStatus = "loading";
    });
    builder.addCase(
      FetchRecordingCourseDetailAsync.fulfilled,
      (state, action) => {
        console.log(action.payload, "<<<action.payload 66");
        state.recordingCourseDetailStatus = "succeeded";
        state.recordingCourseDetail = action.payload;
      }
    );

    builder.addCase(
      FetchRecordingCourseDetailAsync.rejected,
      (state, action) => {
        state.recordingCourseDetailStatus = "failed";
        state.recordingCourseDetailError = action.error.message;
      }
    );

    builder.addCase(
      FetchRecordingCourseFrontendDetailAsync.pending,
      (state) => {
        state.recordingCourseFrontendDetailStatus = "loading";
      }
    );
    builder.addCase(
      FetchRecordingCourseFrontendDetailAsync.fulfilled,
      (state, action) => {
        console.log(action.payload, "<<<action.payload");
        state.recordingCourseFrontendDetailStatus = "succeeded";
        state.recordingCourseFrontendDetail = action.payload.data;
        state.buyStatus = action.payload.buy;
      }
    );

    builder.addCase(
      FetchRecordingCourseFrontendDetailAsync.rejected,
      (state, action) => {
        state.recordingCourseFrontendDetailStatus = "failed";
        state.recordingCourseFrontendDetailError = action.error.message;
      }
    );

    //recordingCourseOrderList plan admin
    builder.addCase(fetchOrderRecordingCourseAsync.pending, (state) => {
      state.recordingCourseOrderListStatus = "loading";
      state.recordingCourseOrderListError = null;
    });
    builder.addCase(
      fetchOrderRecordingCourseAsync.fulfilled,
      (state, action) => {
        state.recordingCourseOrderListStatus = "succeeded";
        state.recordingCourseOrderList = action.payload;
        state.recordingCourseOrderListError = null;
      }
    );
    builder.addCase(
      fetchOrderRecordingCourseAsync.rejected,
      (state, action) => {
        state.recordingCourseOrderListStatus = "failed";
        state.recordingCourseOrderListError = action.error.message;
      }
    );
    builder.addCase(fetchOrderRecordingCourseDetailAsync.pending, (state) => {
      state.recordingCourseOrderListDetailStatus = "loading";
    });
    builder.addCase(
      fetchOrderRecordingCourseDetailAsync.fulfilled,
      (state, action) => {
        state.recordingCourseOrderListDetailStatus = "succeeded";
        state.recordingCourseOrderListDetail = action.payload;
      }
    );

    builder.addCase(
      fetchOrderRecordingCourseDetailAsync.rejected,
      (state, action) => {
        state.recordingCourseOrderListDetailStatus = "failed";
        state.recordingCourseOrderListDetailError = action.error.message;
      }
    );
  },
});

export default RecordingCourseSlice.reducer;
